import { useState } from "react"
import { Chip, Stack, TableCell, TableRow, Tooltip } from "@mui/material"
import { ScheduleCommentaryStatus } from "authoring/lib/enum/schedule-commentary-status.mjs"
import { ContextMenuBar } from "lib/@components/context-menu-bar"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { If } from "lib/@components/switch"
import { scheduleCommentaryLabel } from "../lib/schedule-commentary-label"
import { ScheduleCommentaryMoveMenuItem } from "./schedule-commentary-move-menu-item"
import { ScheduleCommentaryExcludeMenuItem } from "./schedule-commentary-exclude-menu-item"
import { ScheduleCommentaryRevertCategoryMenuItem } from "./schedule-commentary-revert-category-menu-item"
import { ScheduleCommentaryMoveDialog } from "./schedule-commentary-move-dialog"
import { ScheduleCommentaryPreviewButton } from "./schedule-commentary-preview-button"

const READY_TOOLTIP = "This schedule's latest version pushed to Legacy is live in Facilities iQ."
const WAITING_TOOLTIP = "This schedule's latest version pushed to Legacy isn't live in Facilities iQ yet."

export function ScheduleCommentaryUpdateRow({ item }) {
    const [moveDialogOpen, setMoveDialogOpen] = useState(false)
    const excluded = Boolean(item.excludedFromCycle)
    const readinessColor = item.readyToPublish ? "success" : "default"
    const readinessLabel = item.readyToPublish ? "Ready to publish" : "Not yet live"
    const readinessTooltip = item.readyToPublish ? READY_TOOLTIP : WAITING_TOOLTIP
    const approved = item.status === ScheduleCommentaryStatus.APPROVED
    const reviewColor = approved ? "success" : "warning"
    const reviewLabel = approved ? "Approved" : "Pending Review"
    const rowOpacity = excluded ? 0.5 : 1

    return (
        <TableRow data-cy="schedule-commentary-update-row" hover sx={{ opacity: rowOpacity }}>
            <TableCell sx={{ maxWidth: { sm: 320, md: 450 }, borderBottom: "1px solid", borderColor: "divider" }}>
                <TruncatedTypography variant="body1" sx={{ color: "primary.main" }}>
                    {scheduleCommentaryLabel(item)}
                </TruncatedTypography>
            </TableCell>
            <TableCell sx={{ width: 320, whiteSpace: "noWrap", borderBottom: "1px solid", borderColor: "divider" }}>
                <Stack direction="row" spacing={1}>
                    <Tooltip title={readinessTooltip} placement="top" arrow>
                        <Chip size="small" variant="outlined" color={readinessColor} label={readinessLabel} />
                    </Tooltip>
                    <Chip size="small" variant="outlined" color={reviewColor} label={reviewLabel} />
                    <If truthy={excluded}>
                        <Chip size="small" variant="outlined" label="Excluded from this round" />
                    </If>
                </Stack>
            </TableCell>
            <TableCell
                sx={{ width: 50, whiteSpace: "noWrap", borderBottom: "1px solid", borderColor: "divider" }}
                align="right"
            >
                <ScheduleCommentaryPreviewButton item={item} />
            </TableCell>
            <TableCell
                sx={{ width: 50, whiteSpace: "noWrap", borderBottom: "1px solid", borderColor: "divider" }}
                align="right"
            >
                <ContextMenuBar type="scheduleCommentaryUpdateRow">
                    <ScheduleCommentaryMoveMenuItem onOpen={() => setMoveDialogOpen(true)} />
                    <ScheduleCommentaryRevertCategoryMenuItem item={item} />
                    <ScheduleCommentaryExcludeMenuItem item={item} />
                </ContextMenuBar>
                <ScheduleCommentaryMoveDialog
                    open={moveDialogOpen}
                    onClose={() => setMoveDialogOpen(false)}
                    item={item}
                />
            </TableCell>
        </TableRow>
    )
}
